const Keys = {
  ENTER: "Enter",
  TAB: "Tab",
  BACKSPACE: "Backspace",
  UP_ARROW: "ArrowUp",
  DOWN_ARROW: "ArrowDown",
  ESCAPE: "Escape",
  SPACE: " ",
} as const;

export default Keys;
